(document.getElementsByClassName("myFinance-widget").length > 0) &&
!function () { 
        function e() {
            var e = document.createElement("script");
            var n = document.getElementsByTagName('script')[0];
            var a = t + "static/widget/myFinance.js";
            e.type = "text/javascript";
            e.async = !0;
            e.src = a;
            n.parentNode.insertBefore(e, n);
            var c = "myFinance-widget-css";
            if (!document.getElementById(c)) {
                var d = document.getElementsByTagName("head")[0];
                var i = document.createElement("link");
                i.id = c;
                i.rel = "stylesheet";
                i.type = "text/css";
                i.href = t + "static/widget/myFinance.css";
                i.media = "all";
                d.appendChild(i);
            }
        }
    var t = "https://www.myfinance.com/";
    e();
    }();
